<template>
  <main-layout>
    <v-container fluid>
      <div class="mb-2">
          <v-text-field solo dense hide-details clearable :placeholder="$vuetify.lang.t('$vuetify.common.search')" prepend-inner-icon="mdi-magnify" v-model="search" />
      </div>
      <v-data-table dense
        height="calc(100vh - 212px)"
        :headers="headers"
        :items="items"
        :loading="loading"
        :options.sync="options"
        :footer-props="{'items-per-page-options': [20, 25, 30]}"
        :server-items-length="total">
        <template v-slot:[`item.device_status`]="{item}">
          <v-icon :color="item.device_status === 1 ? 'green' : 'grey darken-2'">mdi-checkbox-blank-circle</v-icon>
        </template>
        <template v-slot:[`item.group_name`]="{item}">
          {{item.group.group_name}}
        </template>
        <template v-slot:[`item.last_updated_date`]="{item}">
          {{item.last_updated_date | moment('add', $timezone, 'YYYY-MM-DD HH:mm:ss')}}
        </template>
        <template v-slot:[`item.edit`]="{item}">
          <v-btn tile x-small depressed color="blue" @click="openRemote(item)">{{$vuetify.lang.t('$vuetify.common.remoteControl')}}</v-btn>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog persistent v-model="remote.show" width="1280">
      
      <v-card>
        <v-system-bar>
          <div>REMOTE</div>
          <v-spacer/>
          <v-icon @click="closeRemote()">mdi-close</v-icon>
        </v-system-bar>
        <v-card-text class="d-flex justify-center black pa-4">
            <v-progress-circular indeterminate size="64" v-if="remote.loading" />
            <div class="d-flex frame-wrap" v-else>
              <iframe frameBorder="0" class="flex-grow-1" :src="remote.source"></iframe>
            </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </main-layout>
</template>

<script>
export default {
  methods: {
    async getItem () {
      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      let q = {}
      if (sortBy.length) {
        q.order_by = []
        for (let i=0; i<sortBy.length; i++) {
          q.order_by.push({field: sortBy[i], direction: sortDesc[i] ? 'desc' : 'asc'})
        }
      }
      let params = { page, q: JSON.stringify(q), results_per_page: itemsPerPage }
      let {data} = await this.$http.get('devices', {params})
      this.total = data.num_results
      this.items = data.objects
    },

    async openRemote (item) {
      this.remote.loading = false

      // [NODE ID 없을때 처리 필요]
      if (!item.nodeid) item.nodeid = 'Zx6zs$OMFDKXBqEfHH@MAaUwd$Zi9@QjIpjbR@teootTwD1dsNMO3YBw1wAjjJbd'

      let {data} = await this.$http.get('remote/token')

      let type = 12 // 10 d, 12: t
      let params = [
        'hide=31', 
        `viewmode=${type}`, 
        `gotonode=${item.nodeid}`, 
        `login=${data.result}`
      ].join('&')
      this.remote.source = `${process.env.VUE_APP_MESH_ADDR}/?${params}` 
      this.remote.show = true

    },
    closeRemote () {
      this.remote.show = false
      this.remote.source = null
      this.remote.loading = false
    }
  },
  watch: {
    options: {
      handler () {
        this.getItem()
      },
      deep: true
    }
  },
  data () {
    return {
      loading: false,
      search: '',
      options: {},
      total: 0,
      headers: [
        // { text: '번호', value: 'num', align: 'left', sortable: false },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.status'), value: 'device_status', align: 'left' },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.group'), value: 'group_name', align: 'left', sortable: false },
        { text: this.$vuetify.lang.t('$vuetify.tvsm.header.deviceName'), value: 'alias', align: 'left' },
        { text: 'S/N', value: 'serial_name', align: 'left' },
        { text: this.$vuetify.lang.t('$vuetify.common.modelName'), value: 'model_name', align: 'left', },
        { text: this.$vuetify.lang.t('$vuetify.common.lastUpdated'), value: 'last_updated_date', align: 'left' },
        { text: this.$vuetify.lang.t('$vuetify.common.remoteControl'), value: 'edit', align: 'center', sortable: false }
      ],
      items: [],

      remote: {
        show: false,
        loading: false,
        source: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.frame-wrap {
  width: 100%;
  height: 520px;
}
</style>